import { Spacer } from '@spritz-finance/ui'
import React from 'react'
import styled from 'styled-components'
import { CenteredPageInner } from '../../../../components/Layout/PageContainer'
import { Row } from '../../../../components/Layout/Row'
import { Spinner } from '../../../../components/Spinner/Spinner'
import {
    FullPaymentFragment,
    PaymentProvider,
    useBillsDataQuery,
    usePaymentHistoryQuery,
} from '../../../../graphql/generated/graphql'
import { DirectPaymentCard } from './DirectPaymentCard'
import { NoPaymentHistory } from './NoPaymentHistory'
import { PaymentStatusFilter, usePaymentStatusFilter } from './PaymentStatusFilter'

const AccountsContainer = styled.div`
    padding-bottom: 72px;
`

export const PaymentHistory: React.VFC<{
    provider: PaymentProvider
    EmptyState?: () => JSX.Element
    paymentType: 'offramp' | 'regular'
    filter?: (p: FullPaymentFragment) => boolean
}> = ({ EmptyState = NoPaymentHistory, paymentType }) => {
    const { data, loading } = usePaymentHistoryQuery()
    const { loading: loadingBills } = useBillsDataQuery()

    const payments =
        data?.paymentHistory
            .filter((p) => p?.account?.type !== 'SPRITZ_CARD')
            .filter((payment) => {
                const isOfframp =
                    payment.paymentProvider === PaymentProvider.Checkbook &&
                    payment.account?.ownedByUser
                return paymentType === 'offramp' ? isOfframp : !isOfframp
            }) ?? []

    const { filteredPayments, statusOptions, setStatusFilter } = usePaymentStatusFilter(payments)

    if (loading || loadingBills) {
        return <Spinner />
    }

    if (payments.length === 0) return <EmptyState />

    return (
        <CenteredPageInner $width={564}>
            <AccountsContainer>
                <Row align="flex-end">
                    <PaymentStatusFilter
                        options={statusOptions}
                        setStatusFilter={setStatusFilter}
                    />
                </Row>
                <Spacer height={16} />
                {filteredPayments.map((payment, index) => (
                    <React.Fragment key={payment.id}>
                        <DirectPaymentCard payment={payment} />
                        {index !== filteredPayments.length - 1 && <Spacer height={32} />}
                    </React.Fragment>
                ))}
            </AccountsContainer>
        </CenteredPageInner>
    )
}
